import { Serializer } from 'survey-core';

let ripassoPropsRegistered = false;

/**
 * Registra proprietà custom sulle scelte (ItemValue) e sul radiogroup così Survey Creator
 * e `JSON.stringify` del modello non eliminano `ripasso` / `ripassoMap` dal json_definition.
 */
export function registerSurveyRipassoProperties() {
    if (ripassoPropsRegistered) {
        return;
    }
    if (!Serializer?.addProperty) {
        return;
    }

    if (!Serializer.findProperty('itemvalue', 'ripasso')) {
        Serializer.addProperty('itemvalue', {
            name: 'ripasso',
            type: 'text',
            category: 'general',
            title: 'Argomento da ripassare (se questa opzione è scelta)',
        });
    }

    if (!Serializer.findProperty('radiogroup', 'ripassoMap')) {
        Serializer.addProperty('radiogroup', {
            name: 'ripassoMap',
            type: 'object',
            default: null,
            category: 'general',
            title: 'Mappa ripasso per valore scelta (alternativa alle choice)',
        });
    }

    ripassoPropsRegistered = true;
}
